import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { ArrowUpRight } from "lucide-react";

const TONES = {
  teal: "bg-teal/10 text-teal",
  navy: "bg-navy/10 text-navy",
  emerald: "bg-emerald-100 text-emerald-700",
  amber: "bg-amber-100 text-amber-700",
  sky: "bg-sky-100 text-sky-700",
  rose: "bg-rose-100 text-rose-700",
  violet: "bg-violet-100 text-violet-700",
};

export default function StatCard({ label, value, icon: Icon, tone = "teal", hint, testid, to }) {
  const Root = to ? Link : "div";
  return (
    <Root
      to={to}
      data-testid={testid}
      className={cn(
        "group block bg-white border border-slate-200/80 rounded-xl shadow-sm p-5 transition-[box-shadow,transform,border-color] duration-200",
        to ? "hover:shadow-md hover:-translate-y-0.5 hover:border-teal/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal cursor-pointer" : "hover:shadow-md"
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</div>
          <div className="mt-2 text-2xl font-bold text-slate-900 truncate">{value}</div>
          {hint && <div className="mt-1 text-xs text-slate-400">{hint}</div>}
        </div>
        {Icon && (
          <div className={cn("grid place-items-center h-10 w-10 rounded-lg shrink-0", TONES[tone])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
      {to && (
        <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-slate-400 group-hover:text-teal transition-colors">
          View details <ArrowUpRight className="h-3.5 w-3.5" />
        </div>
      )}
    </Root>
  );
}
